import { getGlobalProject } from "src/utils/globals";
import { createController, createControllerEndpoint, createControllerEndpointWithStatus } from "src/utils/api";
import { TrackedUsersBatchUpdateRequest } from "src/data/types/tracked-users/types";

const project = getGlobalProject() || { UniqueCode: '' };

export default createController('/api/v1/stats/' + project.UniqueCode, {
    batchUpdateTrackedUsers: createControllerEndpoint<string>('POST', '/users/batch-update'),
    batchUpdateTrackedUsersStart: createControllerEndpoint<string>('POST', '/users/batch-update/start'),
    deleteTrackedUser: createControllerEndpointWithStatus<string>('DELETE', '/users/by-username/{username}'),
});
